import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-custom-page-4',
    templateUrl: './custom-page-4.component.html',
    styleUrls: ['./custom-page-4.component.scss'],
})
export class CustomPage4Component implements OnInit {

    constructor(
    ) {

    }
    ngOnInit(): void {

    }
}